<div class="add-supplier-wrapper" *ngIf="!loading">
  <!-- Top Header Bar -->
  <div class="top-header-bar">
    <button class="btn-back" (click)="onCancelClick()">
      <i class="material-icons">arrow_back</i>
      Back
    </button>
    <h1 class="page-main-title">{{ supplier.id > 0 ? "Edit Supplier" : "Add New Supplier" }}</h1>
  </div>

  <!-- Main Content Container -->
  <div class="add-supplier-content">
    <!-- Main Card Box -->
    <div class="add-supplier-card">
      <!-- Card Yellow Header -->
      <div class="card-header-yellow">
        <span class="material-icons header-icon">storefront</span>
        <span class="header-text">Supplier Details</span>
      </div>

      <!-- Card Form Body -->
      <div class="card-body-content">
        <form [formGroup]="addEditSupplierForm">
          <div class="row">

            <!-- Supplier Name -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Supplier Name
                <span
                  matTooltip="Enter full supplier name"
                  style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "
                ></span>
              </label>
              <input type="text" formControlName="name" class="custom-form-input" placeholder="Enter supplier name" />
              <div class="text-danger mt-1"
                *ngIf="addEditSupplierForm.get('name').touched && addEditSupplierForm.get('name').hasError('required')">
                Supplier Name is required
              </div>
            </div>

            <!-- Markets Assigned -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Markets Assigned
                <span
                  matTooltip="Select markets/countries assigned to this supplier"
                  style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "
                ></span>
              </label>

              <div class="custom-market-dropdown-wrapper" style="position: relative;">
                <div
                  class="custom-market-trigger-box"
                  (click)="toggleCountryDropdown($event)"
                >
                  <div class="market-chips-container" *ngIf="addEditSupplierForm.controls.countryId.value?.length > 0">
                    <span
                      *ngFor="let id of addEditSupplierForm.controls.countryId.value"
                      class="market-chip"
                    >
                      {{ getCountryName(id) }}
                      <span class="chip-remove material-icons" (click)="removeCountry(id, $event)">indeterminate_check_box</span>
                    </span>
                  </div>
                  <span class="placeholder-text" *ngIf="!addEditSupplierForm.controls.countryId.value || addEditSupplierForm.controls.countryId.value.length === 0">
                    Select Markets
                  </span>
                  <span class="dropdown-chevron">
                    <img
                      src="/assets/images/down-arrow 1.svg"
                      height="16px"
                      width="16px"
                      [style.transform]="isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'"
                      [style.transition]="'transform 0.3s ease'"
                    />
                  </span>
                </div>

                <!-- Dropdown Content Options Panel -->
                <div class="custom-market-dropdown-content" *ngIf="isCountryDropdownOpen">
                  <!-- Search Input -->
                  <div class="dropdown-search-box">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input
                      type="text"
                      placeholder="Search country"
                      [(ngModel)]="countrySearchText"
                      [ngModelOptions]="{standalone: true}"
                      (input)="filterCountries()"
                      (click)="$event.stopPropagation()"
                      class="search-input"
                    />
                    <mat-icon
                      class="clear-icon"
                      *ngIf="countrySearchText"
                      (click)="countrySearchText = ''; filterCountries(); $event.stopPropagation()"
                    >close</mat-icon>
                  </div>

                  <!-- Options List -->
                  <div class="dropdown-options-list">
                    <ng-container *ngFor="let item of filteredCountries; let i = index">
                      <div class="dropdown-option-item">
                        <mat-checkbox
                          [checked]="isCountrySelected(item.id)"
                          (change)="onCountryCheckboxChange($event, item.id)"
                          (click)="$event.stopPropagation()"
                        >
                          {{ item.name }}
                        </mat-checkbox>
                      </div>
                      <div
                        class="filter-selected-divider"
                        *ngIf="showFilterDivider(i)"
                      ></div>
                    </ng-container>
                    <div class="no-results-found" *ngIf="filteredCountries.length === 0">
                      No countries found
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="col-12 form-group-col">
              <label class="field-label">
                Description*
                <span
                  matTooltip="Detailed description of equipment, fabrication, etc."
                  style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "
                ></span>
              </label>
              <textarea formControlName="description" class="custom-form-textarea" rows="3"
                placeholder="Exhaust Hood, Order Assembly Table (OAT), Fabrication, Refrigeration, Toaster Table, Bun Rack..."></textarea>
            </div>

            <!-- Logo Upload -->
            <div class="col-12 form-group-col">
              <label class="field-label">Logo*</label>
              <div class="logo-upload-section">
                <!-- If Image Uploaded or Exists -->
                <div class="logo-preview-box"
                  *ngIf="supplier.supplierLogoAttachment?.fileName || supplier.imageAttachmentContentAsBase64">
                  <img [src]="supplier.supplierLogoAttachment?.image || supplier.imageAttachmentContentAsBase64"
                    alt="Logo Preview" class="logo-preview-img" />
                  <button type="button" class="btn-remove-logo" (click)="onRemoveSupplierAttachment()">
                    <i class="material-icons">cancel</i>
                  </button>
                </div>

                <!-- If No Image -->
                <div class="logo-upload-dropzone"
                  *ngIf="!supplier.supplierLogoAttachment?.fileName && !supplier.imageAttachmentContentAsBase64"
                  (click)="supplierLogo.click()">
                  <span class="upload-text" style="color: #3F51B5;">Choose Logo</span>
                  <span class="upload-text">*Only JPEG, PNG & BMP</span>
                </div>
                <input hidden type="file" (change)="onSelectImageAttachment($event)" #supplierLogo />

                <div class="text-danger mt-1" *ngIf="invalidImage">
                  Invalid file type. Please upload JPEG, PNG, or BMP.
                </div>
              </div>
            </div>

          </div>

          <!-- Form Footer Buttons -->
          <div class="form-actions-footer">
            <button type="button" class="btn-cancel-outline" (click)="onCancelClick()">
              Cancel
            </button>
            <button type="button" class="btn-submit-amber" [disabled]="!addEditSupplierForm.valid"
              (click)="onSaveSupplier()">
              Submit
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>